<template>
  <div>
    <!--  头部-->
    <div id="head">
      <div id="img_border" ref="img_border"><img id="head_img" ref="head_img"></div>
      <div id="users"><span id="title"><h1>{{ nickname }}</h1></span>
        <span id="time">发布于{{ createTime }}</span></div>

    </div>
    <!--    标题-->
    <div style="padding-top: 15px; display: flex;flex-flow: wrap;padding-left: 15px">
      <!--      <div class="Essence" v-if="tag" ref="Essence">{{ tag }}</div>-->
      <div v-show="postTagVos" class="Essence" ref="Essence" v-for="(item,index) in postTagVos" :key="index"
           :style="{'backgroundColor': item.backgroundImage}">{{ item.tagName }}
      </div>
      <div id="Essence_content">
        {{ title }}
      </div>
    </div>
    <!--帖子图片-->
    <div style="margin-left: 5px; text-align: center">
      <Swipe @change="aaa">
        <SwipeItem
            v-for="(item, index) in postsDetailVos"
            :key="index"
            @click="preview(item)"
            :style="style">
          <img :src="item.picUrl" ref="aa" alt="" style="width: 100%;max-height:416px "/>
        </SwipeItem>
      </Swipe>
    </div>
    <!--    帖子内容-->
    <div id="content">
      <p v-html="content"></p>
    </div>
    <div id="down">
      <span @click="downLoad"> 下载盒子app，查看更多精彩内容</span>
    </div>
    <!-- 分享 -->
    <div class="share" v-show="shareShow" @touchmove.prevent>
      <img :src="share" alt=""/>
      <img :src="close" @click="shareShow = false" alt=""/>
    </div>
  </div>
</template>

<script>
import {postShare} from '@/apis/heziShare.js';
import {Swipe, SwipeItem, ImagePreview, Tag} from 'vant';
import {Toast} from 'vant';

export default {
  name: 'share',
  data() {
    return {
      share: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/share.png",
      close: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/close.png",
      title: '',
      postId: '',
      createTime: '',
      nickname: '',
      picUrl: '',
      videoUrl: '',
      groupName: '',
      postsDetailVos: [],
      postTagVos: [
        {
          backgroundImage: '标签背景',
          postId: 1,
          tagName: '标签名称',
        },
      ],
      content: '',
      downloadUrl: '',
      height: [],
      style: {
        height: '',
      },
      isWX: false,
      shareShow:false
    };
  },
  components: {
    Swipe,
    SwipeItem,
  },
  mounted() {
    this.postId = this.GetUrlString('postId');
    this.getPostDetail();
  },
  methods: {
    preview(item) {
      ImagePreview([item.picUrl]);
    },
    // 获取平台url后的拼接字符串参数方法
    GetUrlString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    //  获取帖子详情
    getPostDetail() {
      let formData = new FormData();
      formData.append('postId', this.postId);
      if (this.postId) {
        postShare(this.postId ? formData : '').then((res) => {
          this.createTime = res.data.createTime;
          this.nickname = res.data.nickname;
          this.postsDetailVos = res.data.postsDetailVos;
          console.log(this.postsDetailVos)
          this.content = res.data.content;
          this.postTagVos = res.data.postTagVos;
          this.title = res.data.title;
          this.$refs.head_img.style.backgroundImage = `url(${res.data.avatar})`;
          this.$refs.img_border.style.backgroundImage = `url(${res.data.frameUrl})`;
          this.downloadUrl = res.data.downloadUrl;
          // 第一张图显示
          if (this.postsDetailVos[0].height > 600) {
            this.style.height = '565px';
          }
        });
      }
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      this.isWX = ua.match(/MicroMessenger/i) == 'micromessenger';
    },
    downLoad() {
      if (this.isWX) {
        this.shareShow = true;
        return;
      }
      window.open(this.downloadUrl, '_blank');
      // window.open(this.downloadUrl);
    },
    // 轮播图切换到下一张控制宽高
    aaa(data) {
      console.log(data)
      this.$refs.aa.map((item, index) => {
        //  根据图片控制宽高
        if (data == index) {
          // 判断是否超过屏幕的四分之三
          if (document.documentElement.clientHeight * 0.75 < item.height) {
            this.style.height = item.height * 0.75 - 100 + 'px';
          } else {
            this.style.height = item.height + 'px';
          }
        }
      });
    },
  },
};
</script>

<style scoped>

#head {
  width: 100%;
  height: 50px;
  padding-top: 9px;
  display: flex;
  /*padding-left: -50px;*/
}

#head_img {
  width: 33.33px;
  height: 33.33px;
  border-radius: 50%;
  float: left;
  margin-right: 10px;
  background-size: 33.33px 33.33px;
  margin-left: 15px;
}

#title h1 {
  font-size: 12.5px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: bold;
  text-align: left;
  color: #000000;
  line-height: 12.5px;
  font-weight: 700;
  margin-top: 5px;

}

#time {
  width: 101.74px;
  height: 7.99px;
  font-size: 8.33px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: left;
  color: #9f9f9f;
  line-height: 12.5px;
}

.Essence {
  width: 50px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  background: #f7664e;
  border-radius: 2.08px;
  font-size: 9.72px;
  font-weight: 400;
  border-radius: 3px;
  margin-left: 5px;
  /*margin-right: 3px;s*/
  margin-top: 10px;
  color: #fff;
}

#Essence_content {
  /*width: 30%;*/
  font-size: 18px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: left;
  color: #000000;
  line-height: 18.06px;
  margin-left: 15px;
  margin-bottom: 15px;
  margin-top: 10px;
  word-wrap: normal;
  /*text-indent:2em*/
}

#content {
  width: 100%;
  /*margin-left: 20px;*/
  font-size: 14.85px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  margin-top: 20px;
  line-height: 23px;
  /*text-align: center;*/
  /*text-indent:2em*/
}

#down {
  text-align: center;
  /*  margin-top: 30px;*/
  /*margin-bottom: 15px;*/
  position: fixed;
  bottom: 2%;
  left: 20%;
}

#down span {
  /*display: block;*/
  padding: 5px;
  width: 400px;
  height: 30px;
  background-color: #d53f26;
  border-radius: 45px;
  color: #fff;
}

#img_border {
  width: 60px;
  height: 60px;
  /*background: url('https://image.hzwxbz2.cn/wxbox/jyy_1658719105261_28e23834d5731d96fd476588c1dfe380.gif');*/
  background-repeat: no-repeat;
  background-size: 60px 60px;
  background-position: left;
  padding-top: 15px;
}

#users {
  margin-top: 15px;
  margin-left: 10px;
}

.share {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
}

.share img:nth-child(1) {
  width: 100%;
}

.share img:nth-child(2) {
  width: 20px;
  display: block;
  margin: 30px auto;
}

</style>
